import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  padding: 12px 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  background: ${({ theme }) => theme.colors.white};
  min-width: 340px;
  cursor: pointer;

  .ant-divider {
    margin: 0;
  }
`;

export const TitleWrapper = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
`;

export const TaskHistoryWrapper = styled.div`
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.link};
`;

export const InfoWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  flex: 1 0 0;

  & :first-child {
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    flex: none;
    color: ${({ theme }) => theme.colors.black5};
  }

  & :last-child {
    display: flex;
    align-items: center;
    gap: 8px;
    overflow: hidden;
    flex: none;
    text-overflow: ellipsis;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
  }
`;

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;
